import '../../assets/fonts'
import '../../../global.d'
import React from 'react'
import { Provider } from 'react-redux'
// TODO(msal): reativar login Microsoft
// import { MsalProvider } from '@azure/msal-react'
import { GlobalStyle } from '../../styles/global'
import Routes from '../routes'
import { store } from '../../../main/store/store'
import Modal from '../ui/components/pop_up/pop_up'

// TODO(msal): reativar login Microsoft
// function App({ instance }: any): JSX.Element {
//   return (
//     <MsalProvider instance={instance}>
//       <Provider store={store}>
//         <GlobalStyle />
//         <Routes />
//         <Modal />
//       </Provider>
//     </MsalProvider>
//   )
// }

function App(): JSX.Element {
  return (
    <Provider store={store}>
      <GlobalStyle />
      <Routes />
      <Modal />
    </Provider>
  )
}

export default App
